import React, { FC } from 'react';
import { List, ListProps } from '@mui/material';

type Props = ListProps & {
  repeat?: number;
  renderItem: (i: number) => React.ReactNode;
}
export const ListLoading: FC<Props> = ({ repeat = 6, renderItem, ...props }) => (
  <List {...props}>
    {[...Array(repeat)].map((it, i) => <React.Fragment key={i}>{renderItem(i)}</React.Fragment>)}
  </List>
);
